(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pizza = function () {
  function Pizza(_ref) {
    var _ref$name = _ref.name;
    var name = _ref$name === undefined ? '' : _ref$name;
    var _ref$dough = _ref.dough;
    var dough = _ref$dough === undefined ? null : _ref$dough;
    var _ref$sauce = _ref.sauce;
    var sauce = _ref$sauce === undefined ? null : _ref$sauce;
    var _ref$veggies = _ref.veggies;
    var veggies = _ref$veggies === undefined ? [] : _ref$veggies;
    var _ref$cheese = _ref.cheese;
    var cheese = _ref$cheese === undefined ? null : _ref$cheese;
    var _ref$pepperoni = _ref.pepperoni;
    var pepperoni = _ref$pepperoni === undefined ? null : _ref$pepperoni;
    var _ref$clams = _ref.clams;
    var clams = _ref$clams === undefined ? null : _ref$clams;

    _classCallCheck(this, Pizza);

    this.name = name;
    this.dough = dough;
    this.sauce = sauce;
    this.veggies = veggies;
    this.cheese = cheese;
    this.pepperoni = pepperoni;
    this.clams = clams;
  }

  _createClass(Pizza, [{
    key: "prepare",
    value: function prepare() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "bake",
    value: function bake() {
      console.log("Bake for 25 minutes at 350");
    }
  }, {
    key: "cut",
    value: function cut() {
      console.log("Cutting the pizza into diagonal slices");
    }
  }, {
    key: "box",
    value: function box() {
      console.log("Place pizza in official PizzaStore box");
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this.name = name;
    }
  }]);

  return Pizza;
}();

exports.default = Pizza;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PizzaIngredientFactory = function () {
  function PizzaIngredientFactory() {
    _classCallCheck(this, PizzaIngredientFactory);
  }

  _createClass(PizzaIngredientFactory, [{
    key: "createDough",
    value: function createDough() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createSauce",
    value: function createSauce() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createCheese",
    value: function createCheese() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createCheese",
    value: function createCheese() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createVeggies",
    value: function createVeggies() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createPepperoni",
    value: function createPepperoni() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "createClam",
    value: function createClam() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return PizzaIngredientFactory;
}();

exports.default = PizzaIngredientFactory;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PizzaIngredientFactory = require('../PizzaIngredientFactory');

var _PizzaIngredientFactory2 = _interopRequireDefault(_PizzaIngredientFactory);

var _ThinCrustDough = require('../ingredients/ThinCrustDough');

var _ThinCrustDough2 = _interopRequireDefault(_ThinCrustDough);

var _MarinaraSauce = require('../ingredients/MarinaraSauce');

var _MarinaraSauce2 = _interopRequireDefault(_MarinaraSauce);

var _ReggianoCheese = require('../ingredients/ReggianoCheese');

var _ReggianoCheese2 = _interopRequireDefault(_ReggianoCheese);

var _Garlic = require('../ingredients/Garlic');

var _Garlic2 = _interopRequireDefault(_Garlic);

var _Mushroom = require('../ingredients/Mushroom');

var _Mushroom2 = _interopRequireDefault(_Mushroom);

var _RedPepper = require('../ingredients/RedPepper');

var _RedPepper2 = _interopRequireDefault(_RedPepper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewYorkPizzaIngredientFactory = function (_PizzaIngredientFacto) {
  _inherits(NewYorkPizzaIngredientFactory, _PizzaIngredientFacto);

  function NewYorkPizzaIngredientFactory() {
    _classCallCheck(this, NewYorkPizzaIngredientFactory);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewYorkPizzaIngredientFactory).apply(this, arguments));
  }

  _createClass(NewYorkPizzaIngredientFactory, [{
    key: 'createDough',
    value: function createDough() {
      return new _ThinCrustDough2.default();
    }
  }, {
    key: 'createSauce',
    value: function createSauce() {
      return new _MarinaraSauce2.default();
    }
  }, {
    key: 'createCheese',
    value: function createCheese() {
      return new _ReggianoCheese2.default();
    }
  }, {
    key: 'createVeggies',
    value: function createVeggies() {
      return [new _Garlic2.default(), new _Mushroom2.default(), new _RedPepper2.default()];
    }
  }, {
    key: 'createPepperoni',
    value: function createPepperoni() {}
  }, {
    key: 'createClam',
    value: function createClam() {}
  }]);

  return NewYorkPizzaIngredientFactory;
}(_PizzaIngredientFactory2.default);

exports.default = NewYorkPizzaIngredientFactory;

},{"../PizzaIngredientFactory":2,"../ingredients/Garlic":4,"../ingredients/MarinaraSauce":5,"../ingredients/Mushroom":6,"../ingredients/RedPepper":7,"../ingredients/ReggianoCheese":8,"../ingredients/ThinCrustDough":9}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Garlic = function Garlic() {
  _classCallCheck(this, Garlic);
};

exports.default = Garlic;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MarinaraSauce = function MarinaraSauce() {
  _classCallCheck(this, MarinaraSauce);
};

exports.default = MarinaraSauce;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mushroom = function Mushroom() {
  _classCallCheck(this, Mushroom);
};

exports.default = Mushroom;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RedPepper = function RedPepper() {
  _classCallCheck(this, RedPepper);
};

exports.default = RedPepper;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReggianoCheese = function ReggianoCheese() {
  _classCallCheck(this, ReggianoCheese);
};

exports.default = ReggianoCheese;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThinCrustDough = function ThinCrustDough() {
  _classCallCheck(this, ThinCrustDough);
};

exports.default = ThinCrustDough;

},{}],10:[function(require,module,exports){
"use strict";

var _NewYorkPizzaStore = require("./stores/NewYorkPizzaStore");

var _NewYorkPizzaStore2 = _interopRequireDefault(_NewYorkPizzaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oPizzaStore = new _NewYorkPizzaStore2.default();
oPizzaStore.orderPizza("cheese");

},{"./stores/NewYorkPizzaStore":15}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Pizza2 = require('../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheesePizza = function (_Pizza) {
  _inherits(CheesePizza, _Pizza);

  function CheesePizza(style, ingredientFactory) {
    _classCallCheck(this, CheesePizza);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CheesePizza).call(this, {
      name: style + ' Cheese Pizza'
    }));

    console.log(_this.name);
    _this.ingredientFactory = ingredientFactory;
    return _this;
  }

  _createClass(CheesePizza, [{
    key: 'prepare',
    value: function prepare() {
      var ingredientFactory = this.ingredientFactory;
      console.log("Preparing " + this.name);
      this.dough = ingredientFactory.createDough();
      this.sauce = ingredientFactory.createSauce();
      this.cheese = ingredientFactory.createCheese();
    }
  }]);

  return CheesePizza;
}(_Pizza3.default);

exports.default = CheesePizza;

},{"../Pizza":1}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Pizza2 = require('../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClamPizza = function (_Pizza) {
  _inherits(ClamPizza, _Pizza);

  function ClamPizza(style, ingredientFactory) {
    _classCallCheck(this, ClamPizza);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ClamPizza).call(this, {
      name: style + ' Clams Pizza'
    }));

    _this.ingredientFactory = ingredientFactory;
    return _this;
  }

  _createClass(ClamPizza, [{
    key: 'prepare',
    value: function prepare() {
      var ingredientFactory = this.ingredientFactory;
      console.log("Preparing " + this.name);
      this.dough = ingredientFactory.createDough();
      this.sauce = ingredientFactory.createSauce();
      this.cheese = ingredientFactory.createCheese();
      this.clams = ingredientFactory.createClam();
    }
  }]);

  return ClamPizza;
}(_Pizza3.default);

exports.default = ClamPizza;

},{"../Pizza":1}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Pizza2 = require('../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PepperoniPizza = function (_Pizza) {
  _inherits(PepperoniPizza, _Pizza);

  function PepperoniPizza(style, ingredientFactory) {
    _classCallCheck(this, PepperoniPizza);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PepperoniPizza).call(this, {
      name: style + ' Pepperoni Pizza'
    }));

    _this.ingredientFactory = ingredientFactory;
    return _this;
  }

  _createClass(PepperoniPizza, [{
    key: 'prepare',
    value: function prepare() {
      var ingredientFactory = this.ingredientFactory;
      console.log("Preparing " + this.name);
      this.dough = ingredientFactory.createDough();
      this.sauce = ingredientFactory.createSauce();
      this.cheese = ingredientFactory.createCheese();
    }
  }]);

  return PepperoniPizza;
}(_Pizza3.default);

exports.default = PepperoniPizza;

},{"../Pizza":1}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Pizza2 = require('../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VeggiePizza = function (_Pizza) {
  _inherits(VeggiePizza, _Pizza);

  function VeggiePizza(style, ingredientFactory) {
    _classCallCheck(this, VeggiePizza);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(VeggiePizza).call(this, {
      name: style + ' Veggie Pizza'
    }));

    _this.ingredientFactory = ingredientFactory;
    return _this;
  }

  _createClass(VeggiePizza, [{
    key: 'prepare',
    value: function prepare() {
      var ingredientFactory = this.ingredientFactory;
      console.log("Preparing " + this.name);
      this.dough = ingredientFactory.createDough();
      this.sauce = ingredientFactory.createSauce();
      this.cheese = ingredientFactory.createCheese();
    }
  }]);

  return VeggiePizza;
}(_Pizza3.default);

exports.default = VeggiePizza;

},{"../Pizza":1}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PizzaStore2 = require('../../../common/PizzaStore');

var _PizzaStore3 = _interopRequireDefault(_PizzaStore2);

var _NewYorkPizzaIngredientFactory = require('../ingredientFactory/NewYorkPizzaIngredientFactory');

var _NewYorkPizzaIngredientFactory2 = _interopRequireDefault(_NewYorkPizzaIngredientFactory);

var _CheesePizza = require('../pizzas/CheesePizza');

var _CheesePizza2 = _interopRequireDefault(_CheesePizza);

var _VeggiePizza = require('../pizzas/VeggiePizza');

var _VeggiePizza2 = _interopRequireDefault(_VeggiePizza);

var _ClamPizza = require('../pizzas/ClamPizza');

var _ClamPizza2 = _interopRequireDefault(_ClamPizza);

var _PepperoniPizza = require('../pizzas/PepperoniPizza');

var _PepperoniPizza2 = _interopRequireDefault(_PepperoniPizza);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PIZZAS = {
  cheese: _CheesePizza2.default,
  veggie: _VeggiePizza2.default,
  clam: _ClamPizza2.default,
  pepperoni: _PepperoniPizza2.default
};

var NewYorkPizzaStore = function (_PizzaStore) {
  _inherits(NewYorkPizzaStore, _PizzaStore);

  function NewYorkPizzaStore() {
    _classCallCheck(this, NewYorkPizzaStore);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewYorkPizzaStore).apply(this, arguments));
  }

  _createClass(NewYorkPizzaStore, [{
    key: 'createPizza',
    value: function createPizza(type) {
      var ingredientFactory = new _NewYorkPizzaIngredientFactory2.default();
      var PizzaConstructor = PIZZAS[type];
      var pizza = null;
      if (PizzaConstructor) {
        pizza = new PizzaConstructor('New York Style', ingredientFactory);
      }
      return pizza;
    }
  }]);

  return NewYorkPizzaStore;
}(_PizzaStore3.default);

exports.default = NewYorkPizzaStore;

},{"../../../common/PizzaStore":16,"../ingredientFactory/NewYorkPizzaIngredientFactory":3,"../pizzas/CheesePizza":11,"../pizzas/ClamPizza":12,"../pizzas/PepperoniPizza":13,"../pizzas/VeggiePizza":14}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PizzaStore = function () {
  function PizzaStore() {
    _classCallCheck(this, PizzaStore);
  }

  _createClass(PizzaStore, [{
    key: "createPizza",
    value: function createPizza() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "orderPizza",
    value: function orderPizza(type) {
      var pizza = this.createPizza(type);

      pizza.prepare();
      pizza.bake();
      pizza.cut();
      pizza.box();
    }
  }]);

  return PizzaStore;
}();

exports.default = PizzaStore;

},{}]},{},[10])

